<template>
  <v-row>
    <v-col>
      <v-row>
        <v-select
            v-if="keyIsLabel"
            :items="unusedKeyItemsAndMe"
            :label="$t('parameters.label.labelName')"
            item-text="label"
            item-value="name"
            v-model="keyModel"
        ></v-select>
        <v-select
            v-else-if="keyIsLexicon"
            v-model="keyModel"
            :items="unusedKeyItemsAndMe"
            item-text="label"
            item-value="name"
            :label="$t('parameters.label.lexicon')"
        ></v-select>
        <v-select
            v-else-if="keyIsLanguage"
            v-model="keyModel"
            :items="unusedKeyItemsAndMe"
            :label="$t('parameters.label.language')"
        ></v-select>
        <v-text-field v-else v-model="keyModel"></v-text-field>
      </v-row>
    </v-col>
    <v-col>
      <v-select
          v-if="valueIsLexicon"
          v-model="valueModel"
          :items="lexicons"
          item-text="label"
          item-value="name"
          :label="$t('parameters.label.lexicon')"
      ></v-select>
      <v-select
          v-else-if="valueIsLabel"
          :label="property.default === null ? '' : property.default"
          :items="extendedLabelsListForSelect"
          item-text="label"
          item-value="name"
          :multiple="property.type === 'array'"
          :chips="property.type === 'array'"
          v-model="valueModel"
      ></v-select>
      <v-select
          v-else-if="valueIsLanguage"
          :label="property.default === null ? '' : property.default"
          :items="possibleLanguages"
          :multiple="property.type === 'array'"
          :chips="property.type === 'array'"
          v-model="valueModel"
      ></v-select>
      <v-select
          v-else-if="valueIsEnum"
          :label="property.additionalProperties.default"
          :items="property.additionalProperties.enum"
          v-model="valueModel"
          single-line
          style="width: 300px"
      ></v-select>
      <div v-else-if="valueIsJson">
        <v-text-field color="primary" v-model="valueModel">
          <template v-slot:append>
            <v-icon
                small
                color="primary"
                @click="jsonEditorDialog = true"
            >
              mdi-pencil
            </v-icon>
          </template>
        </v-text-field>
        <v-dialog
            v-model="jsonEditorDialog"
            max-width="640"
            @click:outside="jsonEditorDialog = false"
            @keydown.esc="jsonEditorDialog = false"
        >
          <v-card height="460px">
            <v-card-title class="headline">{{ $t("parameters.label.jsonEditor") }}</v-card-title>
            <v-card-text>
              <v-jsoneditor
                  v-model="jsonValueModel"
                  :options="options"
                  :plus="false"
                  height="320px"
              ></v-jsoneditor>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="jsonEditorDialog = false">
                {{ $t("parameters.label.validate") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <v-text-field
          v-else
          :rules="rules"
          :placeholder="property.default"
          v-model="valueModel"
          style="width: 250px"
      ></v-text-field>
    </v-col>
    <v-col cols="1">
      <v-tooltip top open-delay="600">
        <template v-slot:activator="{ on }">
          <v-btn
              v-on="on"
              id="btn_deletelabelentry"
              icon
              text
              small
              color="primary"
              @click="removeMapEntry(keyEntry)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("labelSettings.button.delete") }}</span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script>
import {mapState, mapGetters} from "vuex";
// import VJsoneditor from 'v-jsoneditor'

export default {
  inject: ["putMapEntry", "removeMapEntry"],
  props: ["property", "unusedKeyItems", "keyEntry", "valueEntry", "languageRestrictions"],
  // components: {
  //   VJsoneditor
  // },
  data() {
    return {
      options: {
        mode: "code",
        mainMenuBar: true,
        statusBar: false,
      },
      jsonEditorDialog: false,
    };
  },
  computed: {
    ...mapState("settings", ["labelsByName"]),
    ...mapGetters("settings", ["extendedLabelsListForSelect"]),
    ...mapState("lexicons", ["lexicons"]),
    ...mapGetters(["languages"]),
    possibleLanguages() {
      if (this.property.format !== "language")
        return [];
      if (this.languageRestrictions)
        return this.languages.filter(it => this.languageRestrictions.includes(it.value))
      else
        return this.languages
    },
    unusedKeyItemsAndMe() {
      if (this.keyIsLabel) {
        return [this.labelsByName[this.keyEntry]].concat(this.unusedKeyItems);
      } else if (this.keyIsLanguage) {
        return this.languages.filter(it => it.value === this.keyEntry || this.unusedKeyItems.find(it2 => it2.value === it.value));
      } else {
        return [this.keyEntry].concat(this.unusedKeyItems);
      }
    },
    valueIsJson() {
      return (
          this.property.additionalProperties &&
          this.property.additionalProperties.format === "json"
      );
    },
    valueIsLexicon() {
      return (
          this.property.additionalProperties &&
          this.property.additionalProperties.format === "lexicon"
      );
    },
    valueIsLabel() {
      return (
          this.property.additionalProperties &&
          this.property.additionalProperties.format === "label"
      );
    },
    valueIsLanguage() {
      return (
          this.property.additionalProperties &&
          this.property.additionalProperties.format === "language"
      );
    },
    valueIsEnum() {
      return (
          this.property.additionalProperties &&
          this.property.additionalProperties.enum &&
          this.property.additionalProperties.enum.length > 0
      );
    },
    keyIsLexicon() {
      return this.property && this.property.format === "lexicon";
    },
    keyIsLabel() {
      return this.property && this.property.format === "label";
    },
    keyIsLanguage() {
      return this.property && this.property.format === "language";
    },
    valueModel: {
      get() {
        return this.valueEntry;
      },
      set(newValue) {
        this.putMapEntry(this.keyEntry, newValue);
      },
    },
    keyModel: {
      get() {
        if (this.keyIsLabel) {
          return this.labelsByName[this.keyEntry];
        } else {
          return this.keyEntry;
        }
      },
      set(newValue) {
        if (this.keyEntry !== newValue) {
          this.removeMapEntry(this.keyEntry);
          this.putMapEntry(newValue, this.valueEntry);
        }
      },
    },
    jsonValueModel: {
      get() {
        if (!this.valueEntry) return null;
        return JSON.parse(this.valueEntry);
      },
      set(newJsonValue) {
        this.putMapEntry(this.keyEntry, JSON.stringify(newJsonValue));
      },
    },
    rules() {
      const result = [];
      // if (!this.property.default) {
      //   result.push(this.mandatoryParameter)
      // }
      if (
          this.property.minimum === 0 &&
          !this.property.maximum &&
          !this.property.exclusiveMaximum
      ) {
        result.push(this.nonNegativeInteger);
      } else if (
          this.property.exclusiveMinimum === 0 &&
          !this.property.maximum &&
          !this.property.exclusiveMaximum
      ) {
        result.push(this.positiveInteger);
      } else if (
          this.property.maximum === 0 &&
          !this.property.minimum & !this.property.exclusiveMinimum
      ) {
        result.push(this.nonPositiveInteger);
      } else if (
          this.property.exclusiveMaximum === 0 &&
          !this.property.minimum &&
          !this.property.exclusiveMinimum
      ) {
        result.push(this.negativeInteger);
      } else {
        console.log("unhandled rule situation for property:");
        console.log(JSON.stringify(this.property));
      }
      return result;
    },
  },
  methods: {
    focus() {
      console.log("focus");
    },
  },
};
</script>